import { useEffect } from "react";
import { navigate, Route, routes, Switch } from "../../lib/urls";
import { SpacesSettings } from "./SpacesSettings";
import { AISettings } from "./AISettings";
import { ApiKeysSettings } from "./ApiKeysSettings";
import { AuditLogsSettings } from "./AuditLogsSettings";
import { FeatureFlagsSettings } from "./FeatureFlagsSettings";
import { McpSettings } from "./McpSettings";
import { MembersSettings } from "./MembersSettings";
import { NetworksSettings } from "./NetworksSettings";
import { PreferencesSettings } from "./PreferencesSettings";
import { RolesSettings } from "./RolesSettings";
import { SecuritySettings } from "./SecuritySettings";
import { DeviceApproval } from "./ServiceAccountsSettings/DeviceApproval";
import { SettingsLayout } from "./SettingsLayout";
import { SSOSettings } from "./SSOSettings";
import { UserGroupsSettings } from "./UserGroupsSettings";

export function Settings() {
  return (
    <SettingsLayout>
      <Switch>
        <Route path={routes.settings.preferences}>
          <PreferencesSettings />
        </Route>
        <Route path={routes.settings.mcp}>
          <McpSettings />
        </Route>
        <Route path={routes.settings.spaces.new}>
          <SpacesSettings />
        </Route>
        <Route path={routes.settings.spaces.space}>
          {({ spaceId }) => <RedirectToSpaceModal spaceId={spaceId} />}
        </Route>
        <Route path={routes.settings.spaces}>
          <SpacesSettings />
        </Route>
        <Route path={routes.settings.members.serviceAccounts.device}>
          <DeviceApproval />
        </Route>
        <Route path={routes.settings.members}>
          <MembersSettings />
        </Route>
        <Route path={routes.settings.userGroups}>
          <UserGroupsSettings />
        </Route>
        <Route path={routes.settings.roles}>
          <RolesSettings />
        </Route>
        <Route path={routes.settings.apiKeys}>
          <ApiKeysSettings />
        </Route>
        <Route path={routes.settings.ai}>
          <AISettings />
        </Route>
        <Route path={routes.settings.sso}>
          <SSOSettings />
        </Route>
        <Route path={routes.settings.security}>
          <SecuritySettings />
        </Route>
        <Route path={routes.settings.auditLogs}>
          <AuditLogsSettings />
        </Route>
        <Route path={routes.settings.featureFlags}>
          <FeatureFlagsSettings />
        </Route>
        <Route path={routes.settings.networking}>
          <NetworksSettings />
        </Route>
        <Route path={routes.settings}>
          <RedirectToPreferences />
        </Route>
      </Switch>
    </SettingsLayout>
  );
}

function RedirectToPreferences() {
  useEffect(() => {
    navigate(routes.settings.preferences, undefined, { replace: true });
  }, []);
  return null;
}

function RedirectToSpaceModal({ spaceId }: { spaceId: string }) {
  useEffect(() => {
    navigate(routes.settings.spaces, undefined, { replace: true });
    navigate(routes.modal.space, { id: spaceId }, { replace: true });
  }, [spaceId]);
  return null;
}
